export const INDEX = {
  page: 'index',
  route: '/',
};

export const ACCOUNT_INDEX = {
  page: 'account',
  route: '/account',
};

export const ACCOUNT_CUSTOM_PERSON_CREATE = {
  page: 'account/customPerson/create',
  route: '/account/custom-person/create',
};

export const ACCOUNT_CUSTOM_PERSON = {
  page: 'account/customPerson',
  route: '/account/custom-person',
};

export const ACCOUNT_ADD_FRIEND = {
  page: 'account/addFriend',
  route: '/account/add-friend',
};

export const ACCOUNT_SETTINGS = {
  page: 'account/settings',
  route: '/account/settings',
};

export const SIGN_INDEX = {
  page: 'sign',
  route: '/sign',
};

export const BUSINESS_INDEX = {
  page: 'business',
  route: '/business',
};

export const BUSINESS_ORGANIZATIONS = {
  page: 'business/organizations',
  route: '/business/organizations',
};

export const KNOWLEDGE_INDEX = {
  page: 'knowledge',
  route: '/knowledge',
};

export const ABOUT_INDEX = {
  page: 'about',
  route: '/about',
};

export const CAREER_INDEX = {
  page: 'career',
  route: '/career',
};

export const PRESS_INDEX = {
  page: 'press',
  route: '/press',
};

export const BLOG_INDEX = {
  page: 'blog',
  route: '/blog',
};

export const COMPANY_INDEX = {
  page: 'company',
  route: '/company',
};

export const JOBS_INDEX = {
  page: 'jobs',
  route: '/jobs',
};

export const TERMS_INDEX = {
  page: 'terms',
  route: '/terms',
};

export const PRIVACY_INDEX = {
  page: 'privacy',
  route: '/privacy',
};

export const CONTACT_INDEX = {
  page: 'contact',
  route: '/contact',
};

export const FORGOTTEN_PASSWORD_REQUEST = {
  page: 'forgottenPassword/request',
  route: '/forgottenPassword/request',
};

export const FORGOTTEN_PASSWORD_RECOVER = {
  page: 'forgottenPassword/recover',
  route: '/forgottenPassword/recover/:hash',
};

export const INTEGRATION_INDEX = {
  page: 'integration',
  route: '/integration',
};

export const DOCS_FILES = {
  page: 'integration/files',
  route: '/integration/files',
};
